import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './LoginForm.scss';

interface LoginFormProps {}

const LoginForm: React.FC<LoginFormProps> = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const navigate = useNavigate();

  React.useEffect(() => {
    const savedEmail = localStorage.getItem('partner_email');
    const savedPassword = localStorage.getItem('partner_password');
    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRemember(true);
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/partner/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
        if (remember) {
          localStorage.setItem('partner_email', email);
          localStorage.setItem('partner_password', password);
        } else {
          localStorage.removeItem('partner_email');
          localStorage.removeItem('partner_password');
        }
        navigate('/partners/dashboard');
      } else {
        setError(data.message || 'Ошибка входа');
      }
    } catch (err) {
      setError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="partner-login">
      <div className="partner-login__container">
        <h1 className="partner-login__title">Партнерская панель</h1>
        
        <form className="partner-login__form" onSubmit={handleSubmit}>
          {error && (
            <div className="partner-login__error">
              {error}
            </div>
          )}
          
          <div className="partner-login__field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          
          <div className="partner-login__field">
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="partner-login__checkbox-row">
            <input
              id="remember"
              type="checkbox"
              checked={remember}
              onChange={() => setRemember(!remember)}
              disabled={loading}
            />
            <label htmlFor="remember">Запомнить пароль</label>
          </div>
          
          <button 
            type="submit" 
            className="partner-login__submit"
            disabled={loading}
          >
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm; 